import type { RtlsLocation } from 'utils/locationVerification';

/** The fields of a trailer's active lineage the yard pages read. */
export interface ActiveLineage {
  uuid: string;
  notes?: string;
  created_at?: string;
  check_in_time?: string | null;
  /** When an RTLS read last confirmed or set the trailer's current location. */
  rtls_seen_at?: string | null;
  /** What that read verified; `{}` or null when nothing has since the last move. */
  rtls_location?: RtlsLocation | null;
  /** When a manual yard check last verified the trailer at its current spot. */
  last_manual_check_at?: string | null;
}

/** A lineage's campus check-in: carried over across facility moves, else when the lineage began. */
export function lineageCheckIn(
  lineage: { check_in_time?: string | null; created_at?: string | null } | null | undefined
): string | undefined {
  return lineage?.check_in_time || lineage?.created_at || undefined;
}

/** The yard pages' `ActiveLineage` from a GraphQL `active_lineage`, or undefined without one. */
export function toActiveLineage(lineage: any): ActiveLineage | undefined {
  if (!lineage) return undefined;

  return {
    uuid: lineage.uuid,
    notes: lineage.notes,
    created_at: lineage.created_at,
    check_in_time: lineage.check_in_time,
    rtls_seen_at: lineage.rtls_seen_at ?? null,
    rtls_location: lineage.rtls_location ?? null,
    last_manual_check_at: lineage.last_manual_check_at ?? null
  };
}
